import React from 'react';
import b from 'b_';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './PolicySection.css';

const block = b.lock('PolicySection');

export default function PolicySection({ className, grayBackground, lastInRow, children, readOnly }) {
    return <div className={cn(block({ grayBackground, lastInRow, readOnly }), className)}>
        {children}
    </div>;
}

PolicySection.propTypes = {
    grayBackground: PropTypes.bool,
    lastInRow: PropTypes.bool,
    className: PropTypes.string,
    readOnly: PropTypes.bool,
};
